/* eslint-env browser */

(function () {
    function ensureEventGridStyles() {
        if (document.getElementById('kb-event-grid-styles')) {
            return;
        }

        const style = document.createElement('style');
        style.id = 'kb-event-grid-styles';
        style.textContent = [
            '.kb-event-grid-feed {',
            '    padding-top: 0;',
            '}',
            '.kb-event-card {',
            '    border: 1px solid #e61b99ff;',
            '    overflow: hidden;',
            '    border-radius: 12px;',
            '}',
            '.kb-event-card .post-card-image-link {',
            '    margin-bottom: 0;',
            '}',
            '.kb-event-card .post-card-content {',
            '    padding: 24px;',
            '}',
            '.kb-event-card .post-card-tags {',
            '    flex-wrap: wrap;',
            '}',
            '.kb-event-card .post-card-meta {',
            '    margin-top: auto;',
            '    padding-top: 16px;',
            '}',
            '@media (max-width: 767px) {',
            '    .kb-event-card .post-card-content {',
            '        padding: 20px;',
            '    }',
            '}'
        ].join('\n');

        document.head.appendChild(style);
    }

    function escapeHtml(value) {
        return String(value || '').replace(/[&<>"']/g, function (char) {
            return {
                '&': '&amp;',
                '<': '&lt;',
                '>': '&gt;',
                '"': '&quot;',
                "'": '&#39;'
            }[char];
        });
    }

    function formatDate(value) {
        if (!value) {
            return '';
        }

        const date = new Date(value);

        if (Number.isNaN(date.getTime())) {
            return '';
        }

        return new Intl.DateTimeFormat(undefined, {
            month: 'short',
            day: 'numeric',
            year: 'numeric'
        }).format(date);
    }

    document.addEventListener('DOMContentLoaded', async function () {
        ensureEventGridStyles();

        const grids = document.querySelectorAll('.kb-event-grid, .kg-event-grid');

        for (const grid of grids) {
            const tag = grid.dataset.tag || 'current-event';
            const limit = grid.dataset.limit || '4';
            const apiKey = grid.dataset.apiKey || 'cf8ddb9e40b7f4bd23bcefb1d1';

            if (!apiKey || apiKey === 'YOUR_CONTENT_API_KEY') {
                console.error('Event grid failed to load: missing Content API key');
                continue;
            }

            try {
                const params = new URLSearchParams({
                    key: apiKey,
                    filter: 'tag:' + tag,
                    limit: limit,
                    include: 'tags'
                });
                const res = await fetch('/ghost/api/content/posts/?' + params.toString());

                if (!res.ok) {
                    throw new Error('Ghost Content API request failed with status ' + res.status);
                }

                const data = await res.json();
                const posts = Array.isArray(data.posts) ? data.posts : [];

                grid.innerHTML = `
                    <div class="post-feed kb-event-grid-feed">
                        ${posts.map(function (post) {
                            const title = escapeHtml(post.title);
                            const excerpt = escapeHtml(post.excerpt || '');
                            const url = escapeHtml(post.url || '#');
                            const imageAlt = escapeHtml(post.feature_image_alt || post.title || '');
                            const featureImage = post.feature_image ? `
                                <a class="post-card-image-link" href="${url}">
                                    <img class="post-card-image" src="${escapeHtml(post.feature_image)}" alt="${imageAlt}" loading="lazy" />
                                </a>
                            ` : '';
                            const excerptMarkup = excerpt ? `<div class="post-card-excerpt">${excerpt}</div>` : '';

                            return `
                                <article class="post-card keep-ratio kb-event-card${featureImage ? '' : ' no-image'}">
                                    ${featureImage}
                                    <div class="post-card-content">
                                        <a class="post-card-content-link" href="${url}">
                                            <header class="post-card-header">
                                                <h2 class="post-card-title">${title}</h2>
                                            </header>
                                            ${excerptMarkup}
                                        </a>
                                    </div>
                                </article>
                            `;
                        }).join('')}
                    </div>
                `;
            } catch (err) {
                console.error('Event grid failed to load', err);
            }
        }
    });
})();